<template>
  <div class="input-box">
    <label v-if="label !== null" class="label-text">{{label}}</label>
    <validation-provider name="baseInputEditValidationProvider" ref="validationInput" :rules="rules" v-slot="{errors, valid}">
      <div class="form-group" :class="errors.length > 0 ? 'error' : ''">
        <textarea id="" cols="30" rows="2" class="form-control" v-model="displayModel"/>
        <small class="error-text">{{errors[0]}}</small>
      </div>
    </validation-provider>
  </div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import { alpha, required } from 'vee-validate/dist/rules';
import validationMethodsMixin from "../../mixin/validationMethodsMixin";


export default {
  name: "BaseTextAreaInput",
  mixins : [validationMethodsMixin],
  components : {ValidationProvider},
  data :() => {
    return {
      valid : null,
      displayModel : null
    };
  },
  props : {
    label : null,
    rules : String,
    inputModel : null
  },
  model: {
    prop: 'inputModel',
    event: 'change'
  },
  mounted() {
    alpha.message =  'Not alpha numeric';
    extend("alpha", alpha);


    extend("required", {...required,
      message : required.message =  'Required'});

    const max_value = {
      message(field, params, data) {
        let maxValue = params[0];
        let value = params._value_;
        return `${value} is higher than maximum value ${maxValue}`
      },
      validate(value, args) {
        let maxValue = args[0];
        return parseInt(maxValue) >= parseInt(value);
      }
    };

    const min_value = {
      message(field, params, data) {
        let minValue = params[0];
        let value = params._value_;
        return `${value} is higher than maximum value ${minValue}`
      },
      validate(value, args) {
        let minValue = args[0];
        return parseInt(minValue) <= parseInt(value);
      }
    };

    extend("max_value", max_value)
    extend("min_value", min_value)
    this.displayModel = this.inputModel;
  }
}
</script>

<style scoped>

</style>